goog.provide('el8.appchart.refpanel.tags');

goog.require('el8.uiwidget.Component');
goog.require('el8.appchart.dialog.addEditPatientTags');
goog.require('el8.template.appchart.refpanel.tags');


el8.appchart.refpanel.tags = (function() {

    return new el8.uiwidget.Component({

        showFn: function() {
            $('.patient-tags').html(el8.template.appchart.refpanel.tags.content({
                tags: el8.ptdata.currPatient.getTagValues()
            }));
        }
    });

})();

